module.exports = __webpack_public_path__ + "img/Frame-43.f78f917a.svg";